import React from "react";
import styled from "styled-components/macro";
import { IconList } from "../../components/IconList";
import ProgressUpdate from "./ProgressUpdate";
import StatusUpdateRow from "../../components/StatusUpdateRow";
import { formatDateTime } from "../../utils/textUtils";

function CaseStatusUpdate({ statusUpdate, progressUpdate }) {
  if (!statusUpdate) {
    return <p>We haven’t created a live update yet - soon you’ll be able to view the progress of this case here.</p>;
  }

  const numRows = Math.ceil(statusUpdate.sections.length / 2);
  const gridRowStyle = {
    gridTemplateRows: `repeat(${numRows}, min-content)`,
  };

  const statusUpdateRows = statusUpdate.sections.map((section, index) => {
    return (
      <StatusUpdateRow
        key={index}
        title={section.title}
        descriptions={section.descriptions}
        description_blocks={section.description_blocks}
        status={section.status}
      />
    );
  });

  // Two different timestamps — when the snippet was generated vs when the case was last worked
  // on — so each sits next to what it describes.
  return (
    <>
      <ProgressUpdate progressUpdate={progressUpdate} />
      <IconList cols={1} style={gridRowStyle}>
        {statusUpdateRows}
      </IconList>
      <CaseUpdateInfo>Most recent update: {formatDateTime(statusUpdate.last_updated)}</CaseUpdateInfo>
    </>
  );
}

export default CaseStatusUpdate;

const CaseUpdateInfo = styled.div`
  color: var(--juno-color-text-secondary);
  line-height: 1.5;
  margin-top: var(--juno-space-2);
`;
